/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';
// import router from '@/router/index';


const initialState = () => ({
  error: '',
  loading: false,
  // twaggons: {},
});

// State object
const state = initialState();
// Getter functions
const getters = {
  //Getters to local state
  isLoading: (state) => state.loading,
  //getters to ultra store state
  getTWaggon: (state, getters, rootState) => (twaggon_id) => {
    return rootState.Ultra.twaggons[twaggon_id];
  },
  getTWaggons: (state, getters, rootState) => (payload) => {
    if (payload.ids) {
      return payload.ids.map(id => rootState.Ultra.twaggons[id]);
    } else {
      return Object.keys(rootState.Ultra.twaggons).map(id => rootState.Ultra.twaggons[id]);
    }
  },
  getTWaggonStatus: (state, getters, rootState) => (twaggon_id) => {
    let wagon = rootState.Ultra.twaggons[twaggon_id];
    if (wagon.tworkpackages.length === 0) {
      return rootState.Ultra.status_array[0]; // NONE STATUS
    }
    let lowest_index = 6;
    // status_array
    for (var i = 0; i < wagon.tworkpackages.length; i++) {
      let twp = rootState.Ultra.tworkpackages[wagon.tworkpackages[i]];

      if (twp.stop_status !== 'none') {
        return rootState.Ultra.status_array[6]; // STOP STATUS
      }
      let index = rootState.Ultra.status_array.findIndex(status => status.value === twp.status);
      if (index <= lowest_index) {
        lowest_index = index;
      }
    }
    return rootState.Ultra.status_array[lowest_index];
  }
};
// Actions
const actions = {
  //with local mutations mutating Ultra store state
  // tWorkPackageChangePosition({commit, rootState, rootGetters}, payload) {
  //   let payload_cache = JSON.parse(JSON.stringify(payload));
  //   if (!payload_cache.snack_bar.bulk) {
  //     payload_cache.data = {
  //       twork_package_id: rootState.Ultra.twaggons[payload.twaggon_id].tworkpackages[payload.drag_evt.oldIndex],
  //       old_position: payload.drag_evt.oldIndex + 1,
  //       new_position: payload.drag_evt.newIndex + 1,
  //       target_id: rootState.Ultra.twaggons[payload.twaggon_id].tworkpackages[payload.drag_evt.newIndex]
  //     };
  //   }
  //   axios({
  //     url: 'projects/' + payload.project_id +
  //           '/trains/' + payload.train_id +
  //           '/taktareas/' + payload.taktarea_id +
  //           '/twaggons/' + payload.twaggon_id +
  //           '/tworkpackages/0/pushpositionsbulk',
  //     method: 'PUT',
  //     data: {
  //       work_package: payload_cache.data.twork_package_id,
  //       other_work_package: payload_cache.data.target_id,
  //       old_position: payload_cache.data.old_position,
  //       new_position: payload_cache.data.new_position,
  //       snack_bar: payload.snack_bar.bulk,
  //       edit_key: rootGetters['Project/getEditKey']
  //     }
  //   })
  //   .then(resp => {
  //     //commit here is too slow -> anzeige bug
  //     if (!payload_cache.snack_bar.bulk) {
  //       payload_cache.snack_bar.bulk = true;
  //       commit('View/open_snack_bar', {
  //         show: true,
  //         target: {
  //           id: payload_cache.data.work_package,
  //           type: 'work_package',
  //         },
  //         value: {
  //           name: 'Move WorkPackage',
  //           old_value: '',
  //           new_value: ''
  //         },
  //         action: {
  //           path: 'TWaggon/tWorkPackageChangePosition',
  //           payload: payload_cache,
  //         },
  //         check_old_value: false,
  //       },
  //       {root: true}
  //     );
  //   } else {
  //     for (var i = 0; i < resp.data.data.length; i++) {
  //       commit('twork_package_change_position', {rootState, payload: resp.data.data[i]});
  //     }
  //   }
  //   })
  //   .catch(err => {
  //     commit('set_error', extractErrorDetails(err));
  //   });
  //   if (!payload_cache.snack_bar.bulk) {
  //     commit('twork_package_change_position', {rootState, payload});
  //   }
  // },
  tWorkPackageRemoveFromTWaggon({commit, rootState}, payload) {
    commit('twork_package_delete', {rootState, payload: {
      twaggon_id: payload.twaggon_id,
      twork_package_index: payload.drag_evt.oldIndex
    }});
  },
  tWorkPackageAddToWaggon({commit, rootState, rootGetters}, payload) {
    let payload_cache = JSON.parse(JSON.stringify(payload));
    if (!payload_cache.snack_bar.bulk) {
      payload_cache.twork_package_id = rootState.Ultra.twaggons[payload_cache.old_twaggon_id].tworkpackages[payload_cache.drag_evt.oldIndex];
      // store twaggon
      let old_twaggon = rootGetters['TWaggon/getTWaggon'](payload_cache.old_twaggon_id);
      payload_cache.old_twaggon = {
        count: old_twaggon.tworkpackages.length,
        position: old_twaggon.position,
        train_id: payload_cache.train_id,
        id: payload_cache.old_twaggon_id,
        wps: []
      };
      for (let k = 0; k < old_twaggon.tworkpackages.length; k++) {
        let wp = rootGetters['TWorkPackage/getTWorkPackage'](old_twaggon.tworkpackages[k]);
        payload_cache.old_twaggon.wps.push({
          color: wp.color,
          icon: wp.icon,
          token: wp.token
        });
      }
      let twaggon = rootGetters['TWaggon/getTWaggon'](payload_cache.twaggon_id);
      payload_cache.twaggon = {
        count: twaggon.tworkpackages.length,
        position: twaggon.position,
        train_id: payload_cache.train_id,
        id: payload_cache.twaggon_id,
        wps: []
      };
      for (let k = 0; k < twaggon.tworkpackages.length; k++) {
        let wp = rootGetters['TWorkPackage/getTWorkPackage'](twaggon.tworkpackages[k]);
        payload_cache.twaggon.wps.push({
          color: wp.color,
          icon: wp.icon,
          token: wp.token
        });
      }
    }
    axios({
      url: 'projects/' + payload_cache.project_id +
        '/trains/' + payload_cache.train_id +
        '/taktareas/' + payload_cache.taktarea_id +
        '/twaggons/' + payload_cache.old_twaggon_id + //workpackages Old Waggon Id
        '/tworkpackages/0/changetwaggonbulk',
      method: 'PUT',
      data: {
        old_waggon: payload_cache.old_twaggon, //workpackages new waggon
        waggon: payload_cache.twaggon, //workpackages new waggon
        old_waggon_id: payload_cache.old_twaggon_id,
        waggon_id: payload_cache.twaggon_id,
        position: payload_cache.drag_evt.newIndex + 1, //workpackages new position
        work_package_id: payload_cache.twork_package_id,
        edit_key: rootGetters['Project/getEditKey'],
        snack_bar: payload_cache.snack_bar.bulk
      }
    })
    .then(resp => {
      if (!payload_cache.snack_bar.bulk) {
        payload_cache.snack_bar.bulk = true;
        commit('View/open_snack_bar', {
          show: true,
          target: {
            id: payload_cache.twork_package_id,
            type: 'work_package',
          },
          value: {
            name: 'Move WORK.package to other waggon',
            old_value: '',
            new_value: ''
          },
          action: {
            path: 'TWaggon/tWorkPackageAddToWaggon',
            payload: payload_cache,
          },
          check_old_value: false,
        },
        {root: true}
        );
        commit('twork_package_insert', {rootState, payload: {
          twaggon_id: payload_cache.twaggon_id,
          id: payload_cache.twork_package_id,
        }});
      } else {
        for (var i = 0; i < resp.data.data.length; i++) {
          commit('twork_package_delete', {rootState, payload: {
              twaggon_id: resp.data.data[i].old_twaggon_id,
              twork_package_index: payload_cache.drag_evt.oldIndex
              // twork_package_index: resp.data.data[i].twork_package_index
            }});
          commit('twork_package_insert', {rootState, payload: {
            twaggon_id: resp.data.data[i].twaggon_id,
            id: resp.data.data[i].twork_package_id
          }});
        }
      }
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  // tWorkPackageInsert({commit, rootGetters, rootState}, payload) {
  //   let payload_cache = JSON.parse(JSON.stringify(payload));
  //   if (!payload_cache.snack_bar.bulk) {
  //     // store twaggon
  //     let twaggon = rootGetters['TWaggon/getTWaggon'](payload.twaggon_id);
  //     payload_cache.twaggon = {
  //       count: twaggon.tworkpackages.length,
  //       position: twaggon.position,
  //       train_id: payload.train_id,
  //       wps: []
  //     };
  //     for (let k = 0; k < twaggon.tworkpackages.length; k++) {
  //       let wp = rootGetters['TWorkPackage/getTWorkPackage'](twaggon.tworkpackages[k]);
  //       payload_cache.twaggon.wps.push({
  //         color: wp.color,
  //         icon: wp.icon,
  //         token: wp.token
  //       });
  //     }
  //   }
  //   axios({
  //     url: 'projects/' + payload.project_id +
  //       '/trains/' + payload.train_id +
  //       '/taktareas/' + payload.taktarea_id +
  //       '/twaggons/' + payload.twaggon_id +
  //       '/tworkpackages/createbulk',
  //     method: 'POST',
  //     data: {
  //       edit_key: rootGetters['Project/getEditKey'],
  //       work_package: payload.work_package,
  //       snack_bar: payload_cache.snack_bar.bulk,
  //       twaggon: payload_cache.twaggon || false
  //     },
  //   })
  //   .then(resp => {
  //     for (var i = 0; i < resp.data.data.length; i++) {
  //       commit('twork_package_insert', {rootState, payload: {
  //         twaggon_id: resp.data.data[i].waggon.id,
  //         id: resp.data.data[i].id
  //       }});
  //       commit('TWorkPackage/twork_package_insert', {rootState, payload: resp.data.data[i]}, {root: true});
  //     }
  //     router.push({
  //       name: 'TaktPlanWorkPackageEdit',
  //       params: {
  //         tworkpackage_id: resp.data.data[0].id,
  //         }
  //       });
  //     if (!payload_cache.snack_bar.bulk) {
  //       payload_cache.snack_bar.bulk = true;
  //       commit('View/open_snack_bar', {
  //         show: true,
  //         target: {
  //           id: resp.data.data[0].id,
  //           type: 'work_package',
  //         },
  //         value: {
  //           name: 'Insert new WORK.package',
  //           old_value: '',
  //           new_value: ''
  //         },
  //         action: {
  //           path: 'TWaggon/tWorkPackageInsert',
  //           payload: payload_cache,
  //         },
  //         check_old_value: false,
  //       },
  //       {root: true}
  //       );
  //     }
  //   })
  //   .catch(err => {
  //     commit('set_error', extractErrorDetails(err));
  //   });
  // },
  // tWorkPackageDelete({commit, rootState, rootGetters}, payload) {
  //   let payload_cache = JSON.parse(JSON.stringify(payload));
  //   if (!payload_cache.snack_bar.bulk) {
  //     let wp = rootGetters['TWorkPackage/getTWorkPackage'](payload.twork_package_id);
  //     payload_cache.twork_package = {
  //       color: wp.color,
  //       icon: wp.icon,
  //       token: wp.token,
  //       train_id: payload.train_id
  //     };
  //   }
  //   axios({
  //     url: 'projects/' + payload.project_id +
  //       '/trains/' + payload.train_id +
  //       '/taktareas/' + payload. taktarea_id +
  //       '/twaggons/' + payload.twaggon_id +
  //       '/tworkpackages/' + payload.twork_package_id +
  //       '/deletebulk',
  //     method: 'DELETE',
  //     data: {
  //       edit_key: rootGetters['Project/getEditKey'],
  //       snack_bar: payload_cache.snack_bar.bulk,
  //       twork_package: payload_cache.twork_package || false
  //     }
  //   })
  //   .then( resp => {
  //     for (let i = 0; i < resp.data.data.length; i++) {
  //       commit('twork_package_delete', {rootState, payload: {
  //         twaggon_id: resp.data.data[i].waggon.id,
  //         twork_package_index: resp.data.data[i].position - 1
  //       }});
  //       commit('TWorkPackage/twork_package_delete', {rootState, payload: {
  //         twork_package_id: resp.data.data[i].id
  //       }}, {root: true});
  //     }
  //     if (rootState.Ultra.twaggons[payload.twaggon_id].tworkpackages.length > 0) {
  //       let index = Math.max(payload.twork_package_index -1, 0);
        // router.push({
        //   name: 'TaktPlanWorkPackageEdit',
        //   params: {
        //     tworkpackage_id: rootState.Ultra.twaggons[payload.twaggon_id].tworkpackages[index],
        //     }
        //   });
  //     } else {
        // router.push({
        //   name: 'TaktPlanAddWorkPackage',
        //   });
  //     }
  //     if (!payload_cache.snack_bar.bulk) {
  //       payload_cache.snack_bar.bulk = true;
  //       commit('View/open_snack_bar', {
  //         show: true,
  //         target: {
  //           id: -1,
  //           type: 'work_package',
  //         },
  //         value: {
  //           name: 'Delete WORK.packages',
  //           old_value: '',
  //           new_value: ''
  //         },
  //         action: {
  //           path: 'TWaggon/tWorkPackageDelete',
  //           payload: payload_cache,
  //         },
  //         check_old_value: false,
  //       },
  //       {root: true}
  //       );
  //     }
  //   })
  //   .catch(err => {
  //     commit('set_error', extractErrorDetails(err));
  //   });
  // },
};
// Mutations
const mutations = {
  //local state mutations
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err) {
    state.error = err;
  },
  twaggon_loading(state, loading) {
    state.loading = loading;
  },
  //Ultra store state mutations
  twaggon_delete(state, {rootState, payload}) {
    Vue.delete(rootState.Ultra.twaggons, payload.twaggon_id);
  },
  twaggon_insert(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.twaggons, `${payload.id}`, payload);
  },
  twaggons_success(state, {rootState, payload}) {
    Vue.set(rootState.Ultra, 'twaggons', Object.assign({}, rootState.Ultra.twaggons, payload));
  },
  twaggons_insert_bulk(state, {rootState, payload}) {
    Vue.set(rootState.Ultra, 'twaggons', Object.assign({}, rootState.Ultra.twaggons, payload));
  },
  twork_package_change_position(state, {rootState, payload}) {
    let twork_packages = rootState.Ultra.twaggons[payload.twaggon_id].tworkpackages;
    twork_packages.splice(payload.drag_evt.newIndex, 0, twork_packages.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  twork_package_insert(state, {rootState, payload}) {
    rootState.Ultra.twaggons[payload.twaggon_id].tworkpackages.push(payload.id);
  },
  twork_package_delete(state, {rootState, payload}) {
    rootState.Ultra.twaggons[payload.twaggon_id].tworkpackages.splice(payload.twork_package_index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
